import md5 from 'js-md5';

const CHUNK_SIZE = 2 * 1024 * 1024;

export async function computeContentMd5(file) {
  const hasher = md5.create();
  let offset = 0;

  while (offset < file.size) {
    const slice = file.slice(offset, offset + CHUNK_SIZE);
    const buffer = await slice.arrayBuffer();
    hasher.update(buffer);
    offset += CHUNK_SIZE;
  }

  return hasher.hex();
}
